import * as z from "zod";

export const accountChangePasswordSchema = z.object({
    oldPassword: z
    .string()
    .optional(),
    newPassword: z
    .string()
    .optional(),
    confirmNewPassword: z
    .string()
    .optional(),
}).superRefine((data, ctx) => {
    // 회원가입 비밀번호 검증
    if (!data.newPassword || data.newPassword.length < 8) {
        ctx.addIssue({
            path: ["newPassword"],
            code: z.ZodIssueCode.custom,
            message: "비밀번호는 최소 8자 이상이어야 합니다.",
        });
    }

    if (data.newPassword !== data.confirmNewPassword) {
        ctx.addIssue({
            path: ["confirmNewPassword"],
            code: z.ZodIssueCode.custom,
            message: "비밀번호가 일치하지 않습니다.",
        });
    }
});

// 🔹 타입 정의
export type AccountChangePasswordFormValues = z.infer<typeof accountChangePasswordSchema>;